import React from 'react';
import SearchResultsContainer from './SearchResultsContainer';
import SearchResultsNonFound from './SearchResultsNonFound';
import PropTypes from 'prop-types';
import { AttributesParamShape, PaginationPropShape } from '../Infrastructure/propShapes.js'

const SearchResults = tileContainer => ({
    attributes, 
    onAttributeChange, 
    onClearAttributes,
    onToggleFacetExpanded,
    onToggleShowMoreFacet,

    pagination,
    paginationFirstItemIndex,
    onCurrentItemsPerPageChange, 
    onCurrentSortByChange, 
    onCurrentPageIndexChange,
    onShowMobileFacetsToggle,
    onLoadMoreOrPrevious,

    results,
    onResultClick,
    additionalBlocks,
    isFiltered,

    containerData,
    addToCartEndPoint,
    loginPageUrl,
    isUserLoggedIn,
    isOrderRequestOnlyMarket,

    wishlistData,
    updateLists,
    toggleAddToListModal,
    setAddToListLinkClass,
    resultType,
    isCategoryPage,
    customerServiceTextAndLink
}) => {

    return (
        <div>
            {results.length > 0 || attributes.length > 0? 
                <SearchResultsContainer
                    attributes={attributes}
                    onAttributeChange={onAttributeChange}
                    onClearAttributes={onClearAttributes}
                    onShowMobileFacetsToggle={onShowMobileFacetsToggle}
                    onToggleFacetExpanded={onToggleFacetExpanded}
                    onToggleShowMoreFacet={onToggleShowMoreFacet}

                    pagination={pagination}
                    paginationFirstItemIndex={paginationFirstItemIndex}
                    onCurrentItemsPerPageChange={onCurrentItemsPerPageChange}
                    onCurrentSortByChange={onCurrentSortByChange}
                    onCurrentPageIndexChange={onCurrentPageIndexChange}
                    onLoadMoreOrPrevious={onLoadMoreOrPrevious}

                    results={results}
                    onResultClick={onResultClick}
                    additionalBlocks={additionalBlocks}
                    isFiltered={isFiltered}

                    containerData={containerData}
                    addToCartEndPoint={addToCartEndPoint}
                    loginPageUrl={loginPageUrl}
                    isUserLoggedIn={isUserLoggedIn}
                    isOrderRequestOnlyMarket={isOrderRequestOnlyMarket}
                    wishlistData={wishlistData}
                    updateLists={updateLists}
                    toggleAddToListModal={toggleAddToListModal}

                    tileContainer={tileContainer}
                />
            : <SearchResultsNonFound 
                    attributes={attributes}
                    onClearAttributes={onClearAttributes}
                    resultType={resultType}
                    isCategoryPage={isCategoryPage}
                    customerServiceTextAndLink={customerServiceTextAndLink}
                />
            }
        </div>
    );
};

SearchResults.propType = {
    ...AttributesParamShape,
    ...PaginationPropShape,
    results: PropTypes.arrayOf(PropTypes.object),
};

export default SearchResults;